import { ComponentClassNames } from '../../../../util/classNames';
import { memoizeFunction, mergeStyleSets } from '../../../../util/styling';
import { panelCollapsedWidth } from '../../../CollapsiblePanel';

type HeaderClassNames = ComponentClassNames<'quickNavContainer' | 'inner'>;

export const getClassNames = memoizeFunction(
  (isPinned: boolean): HeaderClassNames =>
    mergeStyleSets({
      quickNavContainer: [
        {
          minWidth: 'auto',
          height: '100%',
          zIndex: 1,
        },
        isPinned
          ? undefined
          : {
              position: 'relative',
              width: panelCollapsedWidth,
            },
      ],
      inner: isPinned
        ? {
            height: '100%',
          }
        : {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
          },
    })
);
